import React from "react" 

export default function DistributorBackground() {
    return (
        <div style = {{
            position: "fixed",
            zIndex: "-1",
            width: "100%",
            height: "100%",
            backgroundImage: "url('./audience-sign-up.jpg')",
            backgroundPosition: "0px 0px",
            backgroundSize: "cover",
        }}></div>
    )
}